import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Subject, filter, takeUntil } from 'rxjs';
import { AppConst } from '../../assets/shared.constant';
import {
  GlobalService,
  IUserInformation,
} from '../core/services/global.service';
@Component({
  selector: 'app-dashboard',
  templateUrl: './requester-layout-component.html',
  styleUrl: './requester-layout-component.scss',
})
export class RequesterLayoutComponent implements OnInit {
  isCollapsed = false;
  isAdmin: any;

  constructor(private globalService: GlobalService) {}

  ngOnInit(): void {
    const signedInUser: IUserInformation = this.globalService.getUserDetails();
    this.isAdmin = false;
    if (!signedInUser || signedInUser.email !== '') {
      this.isAdmin = signedInUser.isAdmin;
    }
  }
}
